import { Component, OnInit, ViewChild,TemplateRef } from "@angular/core";
import * as $ from 'jquery';
import * as tracking from 'tracking';
//import tracking from 'tracking';
import 'tracking/build/data/face-min.js';
import 'tracking/build/data/eye-min.js';
import 'tracking/build/data/mouth-min.js';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';

const PrimaryWhite = '#fff';
const SecondaryGrey = '#ccc';

@Component({
  selector: 'app-tira-foto',
  templateUrl: './tira-foto.component.html',
  styleUrls: ['./tira-foto.component.css']
})

export class TiraFotoComponent implements OnInit {

  cameraOn: boolean = false;
  person: any;
  foto: boolean = false;
  repetirFoto: boolean = false;
  loading:boolean = true;

  @ViewChild('video') video: any;
  @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent;

  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public primaryColour = PrimaryWhite;
  public secondaryColour = SecondaryGrey;
  public coloursEnabled = false;
  public loadingTemplate: TemplateRef<any>;
  public config = {
    animationType: ngxLoadingAnimationTypes.circle,
    primaryColour: this.primaryColour,
    secondaryColour: this.secondaryColour,
    tertiaryColour: this.primaryColour,
    backdropBorderRadius: '3px'
  };

  constructor() {
  }

  ngOnInit() {
    const video = this.video.nativeElement;
    setTimeout(function(){
      this.openCamera(video);
    }, 3000);
  }
  
  openCamera = (video) => { //obter vídeo da câmera!
    this.loading = false;
    var n = <any>navigator;
    n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
    n.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
      video.srcObject = stream;
    });
    this.trackFace(video);
  }

  trackFace = (video) => {
    video.play();
    var cont = 0;
    video = document.getElementById('video');
    var canvas = <HTMLCanvasElement>document.getElementById('canvas');
    var context = canvas.getContext('2d');

    this.person = new tracking.ObjectTracker(['face','eye','mouth']);

    //var tracker = new tracking.ObjectTracker('face');
    this.person.setInitialScale(1);
    this.person.setStepSize(1.7);
    this.person.setEdgesDensity(0.1);

    tracking.track('#video', this.person);

    this.person.on('track', (event) => {
      context.clearRect(0, 0, canvas.width, canvas.height);
      if (event.data.length === 0) {
        console.log('rosto ainda não foi detectado');
      }
      else {
        event.data.forEach((rect) => {
          context.strokeStyle = '#006890';
          context.lineWidth = 1;
          context.fillStyle = "#fff";
          context.strokeRect(rect.x, rect.y, rect.width, rect.height);
          //console.log(rect.x, rect.y, rect.width, rect.height);
          // context.font = '11px Verdana';
          // context.fillStyle = "#fff";
          // context.fillText('x: ' + rect.x + 'px', rect.x + rect.width + 5, rect.y + 11);
          // context.fillText('y: ' + rect.y + 'px', rect.x + rect.width + 5, rect.y + 22);
        });
        if (cont==0) {
          this.capturarImagem();
        }
        cont = 1;
      }
    });
  }

  capturarImagem = () => {
    //Captura elemento de vídeo
    var video = (document.querySelector("#video") as HTMLVideoElement);
    //Criando um canvas que vai guardar a imagem temporariamente
    var canvas = <HTMLCanvasElement>document.getElementById('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    //Criando o JPG
    var dataURI = canvas.toDataURL('image/jpeg');
    if (dataURI) {
      console.log(this.foto);
    }
    document.querySelector("#imagemConvertida").setAttribute("src", dataURI);
    $('.btnCapturar').prop('hidden', true);
    $('.btnNovaCaptura').prop('hidden', false);
    this.repetirFoto = !this.repetirFoto
    this.foto = !this.foto;
    this.pararVideo(video);
  }
  
  reiniciarCaptura = () => {
    document.querySelector("#imagemConvertida").setAttribute("src", '');
    // $('.btnCapturar').prop('hidden', false);
    // $('.btnNovaCaptura').prop('hidden', true);
    this.foto = !this.foto;
    this.repetirFoto = !this.repetirFoto
  }

  pararVideo = (video) => {
    var n = <any>navigator;
    n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);
    n.mediaDevices.getUserMedia({ video: false })
  }
}


// WEBPACK FOOTER //
// ./src/app/components/tira-foto/tira-foto.component.ts